<template>
    <footer class="ct-footer">
        <div class="ct-footer-post">
            <div class="container">
                <div class="inner-left">
                    <ul>
                        <li>
                            <a target="_blank" href="https://www.ad-alliance.de/cms/lp/datenschutz_.html">Datenschutz</a>
                        </li>
                        <span class="separator">|</span>
                        <li>
                          <a target="_blank" href="https://www.ad-alliance.de/cms/datenschutz/impressum.html">Impressum</a>
                        </li>
                    </ul>
                </div>
                <div class="inner-right">
                    <p>
                        &copy; Ad Alliance GmbH
                        &bull; Picassoplatz 1
                        &bull; 50679 Köln
                    </p>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style lang="scss" scoped>


    a,
    a:hover,
    a:focus,
    a:active {
        text-decoration: none !important;
        cursor: pointer !important;
        color: inherit
    }

    a {
        -webkit-transition: all .25s ease-in-out;
        transition: all .25s ease-in-out
    }

    .separator {
        display: none;
        color: #fff;
    }

    .container{
        padding: .5rem;
    }

    .ct-footer {
        background-color: #24272d;
        //position: absolute;
        height: 154px;
        width:100%;
        bottom: 0;
    }

    .ct-footer-post {
        background: #24272d;
        padding: 30px 0;
    }

    .ct-footer-post .inner-left,
    .ct-footer-post .inner-right {
        padding: 20px 0;
    }

    .ct-footer-post ul {
        list-style: none;
        padding-left: 0;
        margin: 0;
    }

    .ct-footer-post ul li {
        display: inline-block;
        margin: 0 20px
    }


    .ct-footer-post a {
        color: #fff;
    }

    .ct-footer-post a:hover {
        text-decoration: underline
    }

    .ct-footer-post p {
        color: #fff;
    }

    @media (min-width: 768px) {
        .ct-footer-post p {
            display: inline-block
        }
        .ct-footer-post p + p {
            padding-left: 50px
        }
    }

    @media (min-width: 992px) {

        .ct-footer{
            color: #00b6ed !important;
        }
        .container {
            padding-left: 15rem;
            padding-top: 1rem;
        }

        .separator {
            display: inline-block;
        }

        .ct-footer-post .inner-left,
        .ct-footer-post .inner-right {
            padding: 0;
        }

        .ct-footer-post ul li:first-child {
            margin-left: 0;
        }
    }

    @media (max-width: 991px) {
        .ct-footer{
            color: #d70364 !important;
        }

        .separator {
            display: inline-block;
        }

        .ct-footer-post {
            text-align: center
        }

        .ct-footer-post .inner-right{
            padding-top:0;
        }

        .ct-footer-post{
            padding: 10px 0;
        }
    }


</style>